import { render } from "./SchoolDiaryList.vue?vue&type=template&id=3c7a2736&scoped=true&ts=true"
import script from "./SchoolDiaryList.vue?vue&type=script&lang=ts"
export * from "./SchoolDiaryList.vue?vue&type=script&lang=ts"

import "./SchoolDiaryList.vue?vue&type=style&index=0&id=3c7a2736&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7a2736"]])

export default __exports__